import { RouteObject } from "react-router-dom";
import CheckInLayout from "src/layouts/CheckInLayout";
import QuestionsLayout from "src/layouts/QuestionsLayout";
import { Matches } from "../matches";
import Questions from "src/pages/Questions";
import CompleteCheckInVisit from "src/pages/CompleteCheckInVisit";

export const checkInRoutes: RouteObject[] = [
  {
    element: <CheckInLayout />,
    path: "check-in",
    children: [
      {
        element: <QuestionsLayout />,
        children: [
          {
            path: Matches.QUESTION_ID,
            element: <Questions />,
          },
        ],
      },
      {
        path: "complete",
        element: <CompleteCheckInVisit />,
      },
    ],
  },
];
